<template>
  <div>
    <v-alert v-if="errors.has('fileUpload')" :value="showAlert" type="error" dismissible>
      {{ errors.first('fileUpload') }}
    </v-alert>
    <div class="upload-file__wrapper">
      <i class="fa fa-file-import"></i>
      <span>{{ $t('Drag and Drop Files here') }}</span>
      <input
        type="file"
        v-validate="
          'required|mimes:.xlsx,.csv,.doc,.docx,.pdf,application/msword,application/vnd.openxmlformats-officedocument.wordprocessingml.document,application/vnd.ms-excel'
        "
        name="fileUpload"
        :data-vv-as="$t('File')"
        class="upload-file__input"
        accept=".xlsx,.csv,.doc,.docx,.pdf"
        @change="handleFileChange($event)"
      />
    </div>
    <div class="caption grey--text text-xs-center mt-1">
      {{ $t('upload file size: {size}MB', { size: fileSize }) }}
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      showAlert: false,
      fileSize: 10
    }
  },
  methods: {
    handleFileChange: async function(event) {
      if (event && event.target && event.target.files && event.target.files.length) {
        for (let i = 0; i < event.target.files.length; i++) {
          const file = event.target.files[i]
          if (file.size > this.fileSize * 1024 * 1024) {
            this.$swal.fire({
              type: 'error',
              title: 'File Is Too Large'
            })
            return
          }
        }
      }
      var result = await this.$validator.validate()
      if (!result) {
        this.showAlert = true
        event.target.value = ''
        return
      } else {
        this.showAlert = false
        let files = event.target.files || event.dataTransfer.files
        this.handleSendFile(files[0])
        event.target.value = ''
      }
    },
    handleSendFile(file) {
      if (!file) return
      this.$emit('change', file)
    }
  }
}
</script>
<style lang="css" scoped>
.upload-file__wrapper {
  border: 1px solid #ef8b73;
  position: relative;
  min-height: 120px;
  background: #fef3ef;
  border-radius: 12px;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  font-size: 16px;
}
.upload-file__input {
  position: absolute;
  inset: 0;
  opacity: 0;
  cursor: pointer !important;
}
</style>



// WEBPACK FOOTER //
// src/components/view/intent/gpt/GptConversationUpload.vue